import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './router';
import { configureAmplify } from './config/aws.config';
import { DataMigration } from './components/Migration/DataMigration';
import { MainLayout } from './components/layout/MainLayout';
import { useUserStore } from './stores/userStore';

function App() {
  const settings = useUserStore((state) => state.settings);

  useEffect(() => {
    // Configure AWS Amplify if environment variables are set
    if (import.meta.env.VITE_USER_POOL_ID && import.meta.env.VITE_USER_POOL_CLIENT_ID) {
      try {
        configureAmplify();
        console.log('✅ AWS Amplify configured');
      } catch (error) {
        console.warn('⚠️ Failed to configure AWS Amplify:', error);
      }
    } else {
      console.info('ℹ️ Running in local-only mode (backend not configured)');
    }
  }, []);

  // Apply theme on load
  useEffect(() => {
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(settings.theme);
  }, [settings.theme]);

  return (
    <BrowserRouter>
      <DataMigration />
      <MainLayout>
        <AppRouter />
      </MainLayout>
    </BrowserRouter>
  );
}

export default App;
